<template>
    <div class="kv-expandable" :class="{ 'kv-open': isOpenComputed }">
        <!-- HEADER -->
        <div class="kv-expandable-header" @click="toggle">
            <div class="kv-expandable-trigger">
                <slot name="header" />
                <span class="kv-expandable-icon">
                    <Icon iconClass="ui-chevron-down" :class="{ rotated: isOpenComputed }" />
                </span>
            </div>

            <div class="kv-expandable-actions" v-if="$slots.actions" @click.stop>
                <slot name="actions" />
            </div>
        </div>

        <!-- CONTENT -->
        <div class="kv-expandable-content-wrapper">
            <div class="kv-expandable-content">
                <div class="kv-expandable-content-inner">
                    <slot name="content" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "KvExpandable",
    model: {
        prop: "open",
        event: "input"
    },
    props: {
        open: {
            type: Boolean,
            default: undefined
        },
        defaultOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isOpen: this.defaultOpen
        };
    },
    computed: {
        isOpenComputed: {
            get() {
                return this.open !== undefined ? this.open : this.isOpen;
            },
            set(val) {
                if (this.open !== undefined) {
                    this.$emit("input", val);
                } else {
                    this.isOpen = val;
                }
            }
        }
    },
    methods: {
        toggle() {
            this.isOpenComputed = !this.isOpenComputed;
        }
    }
};
</script>

<style lang="less">
.kv-expandable {
    overflow: hidden;

    /* HEADER (apenas filho direto) */
    >.kv-expandable-header {
        padding: 20px 0px;
        display: flex;
        align-items: center;
        gap: 4px;
        cursor: pointer;
        user-select: none;
        justify-content: space-between;

        >.kv-expandable-trigger {
            display: flex;
            align-items: center;
            gap: 4px;
        }

        >.kv-expandable-actions {
            display: flex;
            align-items: center;
        }
    }

    /* ICON (apenas dentro do header direto) */
    >.kv-expandable-header>.kv-expandable-trigger>.kv-expandable-icon {
        display: flex;
        align-items: center;

        >.ui-chevron-down {
            transition: transform 0.2s ease-in-out;

            &.rotated {
                transform: rotate(180deg);
            }
        }
    }

    /* COLLAPSIBLE CONTENT (filhos diretos) */
    >.kv-expandable-content-wrapper {
        display: grid;
        grid-template-rows: 0fr;
        transition: grid-template-rows 0.25s ease-in-out;

        >.kv-expandable-content {
            overflow: hidden;

            // >.kv-expandable-content-inner {
            //     padding: 20px 0;
            // }
        }
    }

    /* OPEN STATE — só afeta filhos diretos */
    &.kv-open {
        >.kv-expandable-content-wrapper {
            grid-template-rows: 1fr;
        }
    }
}
</style>